module.exports = __webpack_public_path__ + "static/media/box.d36307db.svg";